import { useState } from "react";
import { ReportMaintenance, ReportAssets, ReportRepair, ReportRecommendations } from "@/components/ReportTables";
import { Wrench, Monitor, ClipboardList, Lightbulb } from "lucide-react";

const TABS = [
  { key: "maintenance", label: "Hasil Maintenance", icon: Wrench, testid: "tab-laporan-maintenance" },
  { key: "aset", label: "Aset IT", icon: Monitor, testid: "tab-laporan-aset" },
  { key: "perbaikan", label: "Dalam Perbaikan", icon: ClipboardList, testid: "tab-laporan-perbaikan" },
  { key: "rekomendasi", label: "Rekomendasi", icon: Lightbulb, testid: "tab-laporan-rekomendasi" },
];

export default function Laporan() {
  const [tab, setTab] = useState("maintenance");

  return (
    <div data-testid="laporan-page" className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-heading font-semibold tracking-tight">Laporan Pekerjaan IT</h1>
        <p className="text-sm text-muted-foreground">Laporan hasil maintenance, aset, perbaikan, dan rekomendasi.</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            data-testid={t.testid}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium border transition-colors duration-200 ${
              tab === t.key
                ? "bg-primary text-primary-foreground border-primary"
                : "bg-card text-foreground/70 border-border hover:bg-accent"
            }`}
          >
            <t.icon className="w-4 h-4" />
            {t.label}
          </button>
        ))}
      </div>

      {tab === "maintenance" && <ReportMaintenance />}
      {tab === "aset" && <ReportAssets />}
      {tab === "perbaikan" && <ReportRepair />}
      {tab === "rekomendasi" && <ReportRecommendations />}
    </div>
  );
}
